import React from 'react';
import {
  ProgressWrapper,
  Dot,
  Line,
  ActiveLine,
  TextWrapper,
} from 'screens/BrokerPortal/screens/Registration/components/Progress/Progress.styled';
import { Step } from 'screens/BrokerPortal/screens/Registration/steps';

interface Props {
  currentStep: Step;
}

const Progress: React.FC<Props> = ({ currentStep }) => {
  return (
    <>
      <ProgressWrapper>
        <Dot active={currentStep >= Step.SEARCH_FIRMS} />
        <Line>
          <ActiveLine
            width={
              currentStep >= Step.REGISTER_FIRM
                ? currentStep === Step.DUE_DILIGENCE
                  ? '66%'
                  : currentStep >= Step.PERSONAL_DETAILS
                  ? '100%'
                  : '33%'
                : '0%'
            }
          />
        </Line>
        <Dot active={currentStep >= Step.PERSONAL_DETAILS} />
        <Line>
          <ActiveLine width={currentStep >= Step.VERIFICATION ? '100%' : '0%'} />
        </Line>
        <Dot active={currentStep >= Step.VERIFICATION} />
      </ProgressWrapper>

      <TextWrapper>
        <span>Firm details</span>
        <span>Personal details</span>
        <span>Verification</span>
      </TextWrapper>
    </>
  );
};

export default Progress;
